import type { Locale } from "date-fns"
import { enGB, nb } from "date-fns/locale"

const locales: { [locale: string]: Locale } = { enGB, nb }

export function getLocale() {
  const _window: any = window
  return "__localeId__" in _window ? locales[_window.__localeId__] : locales.nb
}
